import { ISettingsSideNavSection } from '../../SideNavBar/settingsNavType';

export const QUOTE_SHARE_SETTING_KEYS = {
  quoteShareSettings: 'quoteShareSettings',
  quoteShareRules: 'quoteShareRules',
} as const;

export const QUOTE_SHARE_SETTINGS_SECTIONS: ISettingsSideNavSection[] = [
  {
    key: QUOTE_SHARE_SETTING_KEYS.quoteShareSettings,
    label: 'Quote Share Settings',
  },
  {
    key: QUOTE_SHARE_SETTING_KEYS.quoteShareRules,
    label: 'Quote Share Rules',
  },
];
